import { Info, Tooltip } from '@weareopenr/component-library';
import styles from './InfoTooltip.module.scss';

export enum InfoTooltipType {
  HFSS = 'HFSS',
  ENHANCED_BUNDLE = 'ENHANCED_BUNDLE',
}

// Add a new entry here to support a new tooltip purpose - no new component
// needed, just a type + its copy.
const INFO_TOOLTIP_CONFIG: Record<InfoTooltipType, { text: string; ariaLabel: string }> = {
  [InfoTooltipType.HFSS]: {
    text: 'This classification affects how the product can be promoted under government HFSS regulations. Openr will share the classification with downstream aggregators when the product is published.',
    ariaLabel: 'High Fat, Salt or Sugar info',
  },
  [InfoTooltipType.ENHANCED_BUNDLE]: {
    text: "Turn this on to flag the item as an enhanced bundle. Supported channels use this to apply the bundle's built-in savings correctly.",
    ariaLabel: 'Enhanced bundle info',
  },
};

interface IInfoTooltip {
  type: InfoTooltipType;
}

export const InfoTooltip = ({ type }: IInfoTooltip) => {
  const { text, ariaLabel } = INFO_TOOLTIP_CONFIG[type];

  return (
    <Tooltip asChild text={text}>
      <button type="button" className={styles['trigger']} aria-label={ariaLabel}>
        <Info />
      </button>
    </Tooltip>
  );
};
